import { memo } from 'react'

import { Box } from '@mui/material'

import { AnnouncementResponse } from '@tabeeb/contracts/microservices/swagger-article-service'

import ArticleContent, { ArticleContentSkeleton } from '../ArticleContent'
import ArticleName, { ArticleNameSkeleton } from '../ArticleName'
import ArticleDate, { ArticleDateSkeleton } from '../ArticleDate'
import AnnouncementSeverityChip from '../AnnouncementSeverityChip'

export interface AnnouncementProps {
  loading?: boolean
  announcement: AnnouncementResponse
}

const Announcement: React.FC<AnnouncementProps> = ({ loading = false, announcement }) => {
  return (
    <Box
      component='section'
      width='100%'
      height='100%'
      display='flex'
      flexDirection='column'
      alignItems='stretch'
      justifyContent='stretch'
    >
      <Box display='flex' alignItems='center' justifyContent='space-between' mb={1}>
        <Box display='flex' flexDirection='column' minWidth={0}>
          <Box display='flex' alignItems='center'>
            {loading ? <ArticleNameSkeleton /> : <ArticleName name={announcement.Name} />}
            {!loading && <AnnouncementSeverityChip severity={announcement.Severity} />}
          </Box>

          {loading ? <ArticleDateSkeleton /> : <ArticleDate date={announcement.CreatedOn} />}
        </Box>
      </Box>

      {loading ? <ArticleContentSkeleton /> : <ArticleContent content={announcement.Content} />}
    </Box>
  )
}

export default memo(Announcement)
